import React from 'react'
import SideMenuMonitoring, {menuItemsMonitoring} from '../../components/SideMenuMonitoring/SideMenuMonitoring'


import { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import '../DocumentationTeamHealth/DocTeamHealth.css'

const Support = () => {
    const [inactive, setInactive] = useState(false);

    return (
      <>
      			
<div style={{marginTop : "30px"}} >
           <SideMenuMonitoring
            onCollapse={(inactive) => {
             // console.log(inactive);
              setInactive(inactive);
            }}
          />

          <div className={`container ${inactive ? "inactive" : ""}`}>

            {/* improvememt, not recorded in video, its just looping through menuItemsMonitoring
            instead of hard coding all the routes */}
            {menuItemsMonitoring.map((menu, index) => (
              <>
                <Route key={menu.name} exact={menu.exact} path={menu.to}>
               

                  <p>Application monitoring</p>                     
                  <h1 >Support contacts and SLA</h1>
                  <p>Evaluating any of "Agil4You" add-ons or already a paid customer?</p>
                  <p>  We would be happy to help you and answer any your questions in a timely manner following our SLA for Atlassian Marketplace add-ons. </p>

                  <h3> Support contact details </h3>
                  <p>You can create your support request:</p>
                  <ul>
                  <li>send email to : <p style={{color:"blue"}}>support@agil4you.com</p></li>                 
                  </ul>

                  <h3> Marketplace add-ons SLA </h3>
                  <p> Support hours are: Monday - Friday from 10am to 6pm EEST</p>
                  <p> Saturday, Sunday are days off </p>
                  <p> You can expect reply to your email or support ticket within one business day </p>
                

                    
                   

                   {/*  
                  <button style={{
                    backgroundColor: "green",
                    border: "none",
                    color: "white",
                    padding: "15px 32px",
                    textAlign: "center",
                    textDecoration: "none",
                    display: "inline-block",
                    fontSize: "16px",
                    margin: "4px 2px",
                    cursor: "pointer",
                    borderRadius: "10px",
                  }}>Next</button>
                 */}

                 
                 
  
  
                </Route>
                {menu.subMenus && menu.subMenus.length > 0
                  ? menu.subMenus.map((subMenu, i) => (
                      <Route key={subMenu.name} path={subMenu.to}>
                        <h1>{subMenu.name}</h1>
                      </Route>
                    ))
                  : null}
              </>
            ))}
             
  
            {/* <Switch>
              <Route exact path={"/"}>
                <Dashboard />
              </Route>
              <Route exact path={"/content"}>
                <Content />
              </Route>
              <Route path={"/content/courses"}>
                <Courses />
              </Route>
              <Route path={"/content/videos"}>
                <Videos />
              </Route>
              <Route path={"/design"}>
                <Design />
              </Route>
              <Route exact path={"/content-2"}>
                <Content2 />
              </Route>
              <Route path={"/content-2/courses"}>
                <Courses2 />
              </Route>
              <Route path={"/content-2/videos"}>
                <Videos2 />
              </Route>
              <Route path={"/design-2"}>
                <Design2 />
              </Route>
            </Switch> */}
           
          </div>
</div>
      </>
      
    )
  }

export default Support
